import { render, staticRenderFns } from "./ConnectedSidebar.vue?vue&type=template&id=1d1772c8&"
import script from "./ConnectedSidebar.vue?vue&type=script&lang=js&"
export * from "./ConnectedSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports